import React from "react";
import { Link } from "react-router-dom";

/**
 * Encart commercial sous un « reste à charge » chiffré.
 *
 * Cadrage conformité (spec CTO) : on NE connaît PAS le montant des aides
 * complémentaires. Donc aucun montant inventé, aucun RAC recalculé, aucun
 * pourcentage, aucune promesse. On barre le RAC de référence (côté page) et on
 * dit seulement qu'il « peut encore être réduit », sous réserve d'obtention.
 * Objectif : « ce montant n'est peut-être pas définitif », jamais « vous
 * paierez moins ».
 */
const LienAidesComplementaires = ({ className = "" }) => (
  <div className={`mt-3 rounded-lg border border-orange-300 bg-orange-50 px-4 py-3 ${className}`}>
    <p className="text-sm font-bold text-gray-900">
      Ce reste à charge peut encore être réduit<sup>*</sup>
    </p>
    <p className="mt-1 text-sm text-gray-700">
      Nous recherchons les aides complémentaires susceptibles de financer une partie
      de votre reste à charge.{" "}
      <Link
        to="/aides-complementaires"
        className="font-semibold text-orange-700 underline hover:text-orange-800"
      >
        Voir les aides mobilisables →
      </Link>
    </p>
    <p className="mt-2 text-xs leading-relaxed text-gray-500">
      *Sous réserve d'éligibilité, d'instruction et d'obtention effective des aides
      complémentaires. Leur montant ne peut être déterminé avant l'étude de votre
      situation.
    </p>
  </div>
);

export default LienAidesComplementaires;
